import React from 'react';
import API from 'Vulture/lib/API.js';
import CustomIcon from '../Common/CustomIcon/CustomIcon';
import md5 from 'md5';
import TemplateSkeleton from './TemplateSkeleton';
import { v4 as uuidv4, } from 'uuid';
import zlib from 'zlib';

import style from './TemplateSkeletonBuilder.module.css';

class TemplateSkeletonBuilder extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			configName: '',
			skeletonData: {},
		};
	}

	componentDidMount() {
		const { templateConfig } = this.props;
		if (templateConfig && templateConfig.display_name) {
			this.setState({ configName: templateConfig.display_name, });
		}
	}

	async handleSubmit() {
		const { configName, skeletonData, } = this.state;
		const { templateCategory, templateConfig, } = this.props;

		let templateConfigUUID = uuidv4();
		let templateSkeletonUUID = uuidv4();

		if (Object.keys(templateConfig).length > 0) {
			// Keep the generated uuid when either is missing. An unresolved value
			// interpolates literally ("undefined"), and the save endpoint refuses any
			// identifier that is not uuid-shaped rather than minting a replacement —
			// so a missing uuid must become a new one here, not reach the server.
			templateConfigUUID = templateConfig.uuid || templateConfigUUID;
			templateSkeletonUUID = templateConfig?.template_skeleton_list?.template_skeleton?.uuid || templateSkeletonUUID;
		}

		// TODO: move to bronco when _cache is gone
		let data = zlib.gzipSync(JSON.stringify(skeletonData)).toString('base64');
		let hash = md5(data);

		try {
			await API.saveTemplateSkeleton({
				category_uuid: templateCategory.uuid,
				config:        {
					uuid:         templateConfigUUID,
					display_name: configName,
				},
				skeleton: {
					uuid:         templateSkeletonUUID,
					display_name: configName,
					data,
					hash,
				},
			});
		} catch (err) {
			console.error(err);
			alert(`Error Saving: ${err?.body?.error || err.message}`);

			return;
		}

		alert('Save Successful');
		this.props.fetchTemplateData();
		this.props.stateCallback('renderSkeletonBuilder', false);
	}

	updateSkeletonData(skeletonData) {
		this.setState({ skeletonData, });
	}

	renderSkeletonBuilder() {
		const { templateConfig } = this.props;

		let disabled = true;
		let saveButtonClassName = 'button button-save button-disabled';
		if (this.state.configName !== '') {
			disabled = false;
			saveButtonClassName = 'button button-save';
		}

		let existingFlatData = null;
		if (templateConfig?.template_skeleton_list?.template_skeleton) {
			try {
				if (typeof templateConfig.template_skeleton_list.template_skeleton.data === 'string') {
					existingFlatData = JSON.parse(templateConfig.template_skeleton_list.template_skeleton.data);
				}

				// this should not be needed, but if data was corrupted as [object Object]
				// this can help return it to using the corect logic in teh condition above
				if (typeof templateConfig.template_skeleton_list.template_skeleton.data === 'object') {
					existingFlatData = templateConfig.template_skeleton_list.template_skeleton.data;
				}
			} catch (err) {
				console.error('Error parsing skeleton data: ', err);
			}
		}

		return (
			<div className={style.builderPage} data-test-id='templateSkeletonBuilder'>
				<div className={style.title}>
					<h2>Template Skeleton Builder</h2>
					<button
						className='button'
						data-test-id='templateSkeletonBuilderBack'
						onClick={(e) => {
							e.preventDefault();
							this.props.stateCallback('renderSkeletonBuilder', false);
						}}
					>
						<CustomIcon icon='arrow-circle-left' />Theme Editor
					</button>
					<button
						className={saveButtonClassName}
						data-test-id='templateSkeletonBuilderSave'
						disabled={disabled}
						onClick={(e) => {
							e.preventDefault();
							this.handleSubmit();
						}}
					>
						<CustomIcon icon='save' />Save
					</button>
				</div>

				<div className={`${style.secondaryInfo}`}>
					<div className={style.categoryName} data-test-id='templateSkeletonBuilderCategoryName'>{this.props.templateCategory.display_name}
						<span className={style.categoryNameSpacer}>{`>`}</span>
						<input
							onChange={(e) => {
								this.setState({ configName: e.target.value, });
							}}
							value={this.state.configName}
							className={style.configName}
							data-test-id='templateSkeletonBuilderConfigName'
						/>
					</div>
				</div>

				<TemplateSkeleton
					app={this.props.app}
					accountUUID={this.props.accountUUID}
					existingFlatData={existingFlatData}
					form={this.props.form}
					stateCallback={this.props.stateCallback}
					pendingUpdates={this.props.pendingUpdates}
					updateSkeletonData={this.updateSkeletonData.bind(this)}
					settingMap={this.props.settingMap}
					fd={this.props.fd}
				/>
			</div>
		);
	}

	render() {
		return (
			<React.Fragment>
				{this.renderSkeletonBuilder()}
			</React.Fragment>
		);
	}
}

export default TemplateSkeletonBuilder;